"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FreeShopEstimate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative w-full min-h-[400px] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/shop_estimate_texture_background.png)] flex items-center justify-center py-16 px-4">
      <div className={`
          max-w-3xl w-full bg-background/80 backdrop-blur-md rounded-[12px] shadow-[0_4px_16px_rgb(0_0_0_/_0.12),_0_2px_6px_rgb(0_0_0_/_0.08)] p-8 md:p-12 text-center
          transition-all duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
          Free Shop Estimate
        </h2>
        <p className="text-lg text-muted mb-8">
          Get a no-obligation, complimentary estimate for your mechanical system needs. Our expert technicians are ready to assess your project and provide you with a detailed quote.
        </p>
        <Button asChild className="bg-accent text-foreground hover:bg-accent-hover shadow-[0_2px_6px_rgba(0,0,0,0.15)] hover:shadow-[0_4px_16px_rgb(0_0_0_/_0.12),_0_2px_6px_rgb(0_0_0_/_0.08)] hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 transition-all duration-[120ms] ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-[12px] px-6 py-3 font-semibold">
          <Link to="/ContactPage">
            Request Your Free Estimate
          </Link>
        </Button>
      </div>
    </section>;
}